import { createApi } from "@reduxjs/toolkit/query/react";
import { gql } from "graphql-request";
import customBaseQuery from "../../../utils/customBaseQuery";

export const ContentApi = createApi({
  reducerPath: "getContentListApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getContentList: builder.query({
      query: ({ id, preview = false }: any) => {
        return {
          url: "/graphql",
          body: gql`
          query {
            fetchContent(id: "${id}", preview:${preview}) {
              timestamp
              error
              version
              data {
                videosettings
                pkid
                title
                externalownerlist
                sourcename
                sourcetype
                cataloged
                searchtags {
                  defaultTag
                  contentCategory
                  contentSubCategory
                  contentUsage
                  contentRegion
                  contentDomain
                }
                status
                id
                socialinteractions {
                        contentId
                        contentType
                        interactionCriteria 
                    }
                isacknowledged
                artifacttype
                artifacttext
                artifactid
                artifacturl
                launchdate
                expirydate
                updatedat
                createdby
                language
                shortdescription
                prerequisite
                expectedoutcome
                longdescription
                duration
                brandingurls {
                  promo
                  thumbnail
                  banner
                }
                stakeholder {
                  owner
                  observer
                  nominationApprover
                  reviewer
                }
                branding {
                  promo
                  thumbnail
                  banner
                }
                sectionlist {
                  duration
                  questions
                  sectionname
                  sectiontype
                        }
                difficultylevel
                pageno
                targetaudience
                artifacturl
                weblink
                launchtype
                skills {
                  type
                  skillid
                  parentskill
                  preferredskillname {
                    en_UK
                    en_US
                  }
                }
                skillnamelist
                learningobjective
                contentlist {
                  type
                  title
                  chapterContentList {
                    type
                    title
                  }
                }
              }
            }
          }
        `
        };
      },
      extraOptions: { service: "Catalog" }
    })
  })
});

export const { useGetContentListQuery, useLazyGetContentListQuery } =
  ContentApi;
